import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExitPageComponent } from './exit-page.component';

/**
 * Open exit dialog modal
 *
 * @param dialog mat dialog instance
 * @returns promise MatDialog ref
 */
export const openExitAppDialog = (
  dialog: MatDialog,
  showExitConfirmation: boolean = false
): Promise<MatDialogRef<ExitPageComponent>> => {
  return dialog
    .open(ExitPageComponent, {
      maxWidth: '65vw',
      maxHeight: '25vh',
      minWidth: '65vw',
      data: { showExitConfirmation },
    })
    .afterClosed()
    .toPromise();
};